module.exports = __webpack_public_path__ + "static/media/laptop-basics.e342eac6.png";